export const mockWorkflow = {
  levels: [
    {
      level: 0,
      condition: 'serial',
      approvers: [{ name: 'Somchai Rattanakorn', status: 4 }],
    },
    {
      level: 1,
      condition: 'serial',
      approvers: [{ name: 'Nattapong Chaiyasit', status: 2 }],
    },
    {
      level: 1,
      condition: 'serial',
      approvers: [{ name: 'Siriporn Chansri', status: 3 }],
    },
    {
      level: 2,
      condition: 'parallel_or',
      approvers: [
        { name: 'Kanyarat Srisuk', status: 1 },
        { name: 'Piyawat Thongsuk', status: 0 },
      ],
    },
  ],
}
